import { ACTIONS } from '../../../constants/app-constants';

function setApiStatus(apiName, status) {
	return {
		type: 'SET_API_STATUS',
		payload: {
			[apiName]: status,
		},
	};
}

function resetApiStatus(apiName) {
	return {
		type: 'SET_API_STATUS',
		payload: {
			[apiName]: null,
		},
	};
}

function resetApiResponse(apiName) {
	return {
		type: 'SET_API_RESPONSE',
		payload: {
			[apiName]: null,
		},
	};
}

function setBranches(data) {
	return {
		type: 'SET_BRANCHES',
		payload: data,
	};
}

function setSelectedBranch(data) {
	return {
		type: 'SET_SELECTED_BRANCH',
		payload: data,
	};
}

function setCurrentPage(data) {
	return {
		type: 'SET_CURRENT_PAGE',
		payload: data,
	};
}

function setAccountBooks(data) {
	return {
		type: ACTIONS.SET_ACCOUNT_BOOKS,
		payload: data,
	};
}

function setSalesPerson(data) {
	return {
		type: ACTIONS.SET_SALES_PERSONS,
		payload: data,
	};
}

function setClasses(data) {
	return {
		type: 'SET_CLASSES',
		payload: data,
	};
}

function setVoucherHead(data) {
	return {
		type: 'SET_VOUCHERS_HEAD',
		payload: data,
	};
}
function setAssets(data) {
	return {
		type: 'SET_ASSETS',
		payload: data,
	};
}
function setVehicles(data) {
	return {
		type: 'SET_VEHICLES',
		payload: data,
	};
}
function setVendors(data) {
	return {
		type: 'SET_VENDORS',
		payload: data,
	};
}
function setCredentials(data) {
	return {
		type: 'SET_CREDENTIALS',
		payload: data,
	};
}
function setPartNumbers(data) {
	return {
		type: 'SET_PART_NUMBERS',
		payload: data,
	};
}
function setBatch(data) {
	return {
		type: 'SET_BATCHES',
		payload: data,
	};
}
function setStates(data) {
	return {
		type: 'SET_STATES',
		payload: data,
	};
}
function setUsers(data) {
	return {
		type: 'SET_USERS',
		payload: data,
	};
}

export {
	setApiStatus,
	resetApiStatus,
	resetApiResponse,
	setBranches,
	setSelectedBranch,
	setCurrentPage,
	setAccountBooks,
	setStates,
	setClasses,
	setVoucherHead,
	setAssets,
	setVehicles,
	setBatch,
	setPartNumbers,
	setVendors,
	setCredentials,
	setUsers,
	setSalesPerson
};
